import { useState } from "react";
import { useTranslation } from "react-i18next";

// Rendered by the router's errorElement when any route inside throws during
// render. The cart in localStorage is the most common culprit (a stale or
// partially-shaped item makes a downstream component blow up before it can
// guard against the missing field), and the user can otherwise be locked out
// across logins because the bad cart is restored from localStorage on every
// page load. The "Reset cart" button gives non-technical users a one-click
// escape hatch without needing DevTools.
function clearCartStorage() {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key && (key.endsWith("_products") || key.endsWith("_activeOrder"))) {
      localStorage.removeItem(key);
    }
  }
}

export function RouteErrorView() {
  const { t } = useTranslation();
  const [isResetting, setIsResetting] = useState(false);

  function handleReset() {
    setIsResetting(true);
    clearCartStorage();
    window.location.href = "/";
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        gap: 16,
        padding: 16,
        textAlign: "center",
      }}
    >
      <div>{t("compMisc.errorLoadingPage")}</div>
      <div style={{ fontSize: 13, color: "#555", maxWidth: 480 }}>
        {t("compMisc.tryRefreshBelow")}
      </div>
      <button
        onClick={handleReset}
        disabled={isResetting}
        style={{
          padding: "8px 16px",
          borderRadius: 6,
          border: "1px solid #888",
          background: isResetting ? "#eee" : "#fff",
          cursor: isResetting ? "default" : "pointer",
          fontWeight: 600,
        }}
      >
        {isResetting ? t("compMisc.refreshing") : t("compMisc.refreshPage")}
      </button>
    </div>
  );
}
